$(function() {
    var $win    = $(window);
    var scrubs  = [];
    var windowHeight = $win.height();

    // 1) Gather all videos and their matching spacer (by index)
    $('.scrub-video').each(function(i, vidEl) {
      var $sp = $('.spacer').eq(i);
      vidEl.pause();                         // ensure no auto-play
      scrubs.push({ vid: vidEl, $sp: $sp, ready: false });

      // 2) Wait until we know video duration
      vidEl.addEventListener('loadedmetadata', function() {
        scrubs[i].ready = true;
      });
    });

    // 3) On every scroll, scrub each “ready” video
    $win.on('scroll', function() {
      var scrollTop = $win.scrollTop();

      scrubs.forEach(function(item) {
        if (!item.ready || !item.$sp.length) return;

        var top    = item.$sp.offset().top;
        var h      = item.$sp.outerHeight() - windowHeight;
        var prog   = (scrollTop - top) / h;
            prog   = Math.max(0, Math.min(1, prog));

        item.vid.currentTime = prog * item.vid.duration;
      });
    });



    // GSAP SCROLL

    gsap.registerPlugin(ScrollTrigger);

    // Configuration
    const frameCount = 299;
    const canvas = document.getElementById("canvas");
    const triggerTgt = document.querySelector(".trigger");
    const imageSrc = canvas.getAttribute('data-image-src');
    const imageType = canvas.getAttribute('data-image-type') || 'webp';
    const currentFrame = index => imageSrc+`${index.toString().padStart(4, '0')}.${imageType}`;
    
    const images = [];
    const imageSeq = {
      frame: 0
    };
    
    // Preload images
    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);
      images.push(img);
    }
    

    const context = canvas.getContext("2d");
    var explosiveWidth = canvas.getAttribute('data-image-width') ? canvas.getAttribute('data-image-width') : 1920;
    var explosiveHeight = canvas.getAttribute('data-image-height') ? canvas.getAttribute('data-image-height') : 1080;
    canvas.width = explosiveWidth;
    canvas.height = explosiveHeight;
    // canvas.width = window.innerWidth;
    // canvas.height = window.innerHeight;
    
    images[0].onload = render;
    
    function render() {
      context.clearRect(0, 0, canvas.width, canvas.height);
      const img = images[imageSeq.frame];
      const scale = Math.min(canvas.width / img.width, canvas.height / img.height);
      const x = (canvas.width - img.width * scale) / 2;
      const y = (canvas.height - img.height * scale) / 2;
      context.drawImage(img, x, y, img.width * scale, img.height * scale);
    }
    
    // Scroll-triggered animation
    gsap.to(imageSeq, {
      frame: frameCount - 1,
      snap: "frame",
      ease: "none",
      scrollTrigger: {
        trigger: triggerTgt,
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        onUpdate: render
      }
    });
    
    // Handle resize
    window.addEventListener('resize', () => {
      // canvas.width = window.innerWidth;
      // canvas.height = window.innerHeight;
      render();
    });
 


  });